import { ReactElement } from "react";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_PROFILE_ROLE } from "../../../store/selectors/profileSelectors";
import { SELECT_APPLICATION_STATUS } from "../../../store/selectors/requestAppSelector";
import { STATUS_APPLICATION, USER } from "../../../types/indexTypeEnum";
import { DocRequestList } from "./DocForAgent/DocRequestList";
import { DocForCredit } from "./DocForCredit/DocForCredit";

export function DocList(): ReactElement {
  const role = useAppSelector(SELECT_PROFILE_ROLE);

  const STATUS_TYPE = useAppSelector(
    SELECT_APPLICATION_STATUS,
  ) as STATUS_APPLICATION;

  // TODO: добавил для кошника на статусе черновик у заявки грузить документ
  if (
    role === USER.AGENT_SIMPLE ||
    role === USER.CLIENT_SIMPLE ||
    (role === USER.SUPPORT_CREDIT && STATUS_TYPE === "draft")
  ) {
    return <DocRequestList />;
  }

  if (
    role === USER.SUPPORT_CREDIT ||
    role === USER.SUPPORT_ADMIN ||
    role === USER.MANAGER
  ) {
    return <DocForCredit />;
  }
  return <></>;
}
